import { useContext } from 'react';
import { IFiltersSelectors, IFiltersState, IStoreState } from 'src/app/props';
import { appActionTypes } from 'src/app/newActionTypes';
import { GlobalStateContext } from 'src/app/providers/GlobalStateContext';
import { useSelectors } from 'src/utils/storeHelpers';

// site specific filter data
export const useFilterDataSelectors: () => IFiltersSelectors = () => {
  const state: IStoreState = useContext(GlobalStateContext);
  const filtersState: IFiltersState = state.filters;

  return useSelectors(filtersState, (state: IFiltersState) => ({
    getOperationsFilterData: () => state.filters.operations,
    getNoiseEventsFilterData: () => state.filters.noiseEvents,
    getInfringementFilterData: () => state.filters.infringements,
    getReportsFilterData: () => state.filters.reports,
    getModelingAircraftAssignmentsData: () => state.filters.modelingAircraftAssignments,
    hasCompletedInitialLoad: () => state.initialLoadCompleted,
    hasAccessFailed: () => state.failedToAccessFilters,
    getAirtrakFilterData: () => state.filters.airtrak,
    getComplaintsFilterData: () => state.filters.complaints,
    getSettingsFiltersData: () => state.filters.settings,
  }));
};

export const filterDataReducer = (state: IFiltersState, action: any) => {
  switch (action.type) {
    case appActionTypes.UPDATE_FILTERS:
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload },
        failedToAccessFilters: false,
        initialLoadCompleted: true,
      });
    case appActionTypes.FILTERS_ERROR:
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload },
        failedToAccessFilters: true,
        initialLoadCompleted: true,
      });
    case appActionTypes.UPDATE_OPERATIONS_FILTERS:
      return Object.assign({}, state, {
        filters: { ...state.filters, operations: action.payload },
      });
    case appActionTypes.UPDATE_REPORTS_FILTERS:
      return Object.assign({}, state, {
        filters: { ...state.filters, reports: action.payload },
      });
    case appActionTypes.UPDATE_MODELING_AIRCRAFT_ASSIGNMENTS_FILTERS:
      return Object.assign({}, state, {
        filters: { ...state.filters, modelingAircraftAssignments: action.payload },
      });
    case appActionTypes.UPDATE_AIRTRAK_FILTERS:
      return Object.assign({}, state, {
        filters: { ...state.filters, airtrak: action.payload },
      });
    case appActionTypes.UPDATE_INFRINGEMENTS_FILTERS:
      return Object.assign({}, state, {
        filters: { ...state.filters, infringements: action.payload },
      });
    case appActionTypes.UPDATE_NOISE_EVENTS_FILTERS:
      return Object.assign({}, state, {
        filters: { ...state.filters, noiseEvents: action.payload },
      });
    case appActionTypes.UPDATE_COMPLAINTS_FILTERS:
      return Object.assign({}, state, {
        filters: { ...state.filters, complaints: action.payload },
      });
    case appActionTypes.UPDATE_SETTINGS_FILTERS:
      return Object.assign({}, state, {
        filters: { ...state.filters, settings: action.payload },
      });
    default:
      return state;
  }
};
